import { Store, flashSlice } from 'app'

export class Flash {
    static add = (action) => {
        Store.dispatch(flashSlice.actions.add(action))
    }
}
